import BaseComponent from '../../../js/base-component'
import { Splide } from '@splidejs/splide/build/complete/complete';

class CategorySlider extends BaseComponent {
  constructor(options) {
    super(options);
  }
  onInit() {
    this.splide = new Splide(this.element.querySelector('.u-category-slider__slider'), {
        arrows: false,
        pagination: true,
        perMove: 1,
        destroy: true,
        breakpoints: {
            767: {
			          perPage: 2,
		    },
            1023: {
                perPage: 3,
            },
            1259: {
              perPage: 5,
            },
        },
    } );

    // this.splide.on('mounted', () => {
    //   const pagination = this.element.querySelector('.splide__pagination');

    //   let paginationWrapper = document.createElement('div');
    //   paginationWrapper.classList.add('splide__pagination-wrapper');
    //   pagination.parentElement.insertBefore(paginationWrapper, pagination);
    //   paginationWrapper.appendChild(pagination);
    // });

    // this.splide.on('active', function (e) {
    //   e.slide.parentElement.style.height = 'initial';
    //   e.slide.parentElement.style.height = e.slide.querySelector('.u-link-slider__item').offsetHeight + 'px';
    // });

      this.splide.mount();
  }
}

export default {
  name: 'CategorySlider',
  definition: CategorySlider
};